import React from "react";

const Profile = () => {
    return (
        <div className=" "
            style={{
                padding: "50px;",
                paddingLeft: "250px;",
                paddingRight: "250px;",
            }}>
            <div className="bg-white p-4  ">

                <div className="row">
                    <div className="col-md-6">
                        <h4>OUR GROUP OF FIRMS</h4>

                        <div> 1)  Shri Shakti Hardweare And Stationries Ilkal</div>
                        <div> 2)  Ashok Medical Stores Ilkal</div>
                        <div> 3)  Shri Shakati Enterprises Ilkal</div>
                        <div> 4)  Ashok Medical agencies ilkal</div>
                        <div> 5)  Bijjal Associeates Arechtect And Engineers Hospet & Ilkal</div>
                        <div> 6)  Bijjal Automobiles Bajaj Auto Dealers Ilkal</div>
                        <div> 7)  Bijjal Petroleums Ilkal</div>
                        <div> 8)  Vittal Autoprix Yamaha India LTD Dealer Ilkal</div>
                        <div> 9)  Bijjal Diginers Ilkal & Hospet</div>
                    </div>




                    <div className="col-md-6">
                        <div className="border p-3 m-1">
                            <h6> PROFILE AND ADDRESS  </h6>


                            <div> ASHOK MEDICAL AGENCIES </div>
                            <div> PAHRAMACEUTICAL DISTRIBOUTORS </div>
                            <div> OPP SVM COLLEGE</div>
                            <div> NEAR KSRTC BAUSTAND </div>
                            <div> I AND II FLOR </div>
                            <div> ILKAL-587125 ( K A ) </div>
                            <div> TAL : ILKAL</div>
                            <div> DIST : BAGALKOT</div>
                        </div>
                    </div>
                </div>







                <h5>PARTNERS :</h5>
                <div>1)  ASHOK V BIJJAL</div>
                <div>2)  RAGHAVENDRA A BIJJAL</div>
                <div>3)  SOMASHEKAR  A BIJJAL</div>
                <div>4)  VITTAL A BIJJAL</div>






            </div>
        </div>
    );
};

export default Profile;
